import { Debug } from "@react-three/cannon";
//Cannon Physics object for inside box
export function CannonDebugger({ children, active = false, ...props }) {
  if (!active) return children;

  return <Debug {...props}>{children}</Debug>;
}
